import React from 'react'
import { pinguinoAzulRegistro } from '../../assets/ImgLinks'
import Spinner from 'react-bootstrap/Spinner'

const RegistrandoUser = () => {
  return (
    <div className='p-3'>
      <div className='d-flex align-items-center justify-content-center'>
        <img style={{width:'20vw'}} className='rounded' src={pinguinoAzulRegistro} alt="pinguinoAzulRegistro" />
        <h3 style={{color:'#3ABDBC'}} className='fs-1 ms-3'>REGISTRANDO USUARIO</h3>
      </div>
      <br />
      <div className='d-flex justify-content-center'>
      <Spinner/>
      </div>
      
    </div>
  )
}

export default RegistrandoUser